import React from 'react'
import './styles.scss'
import FeedBackCard from './FeedBackCard'
import FeedBackData from 'data/portfolio/feedback'

const Feedback = () => {
  return (
    <div className="feedback">
      <h3>Feedback</h3>
      <div>
        <FeedBackCard FeedBackData={FeedBackData} />
      </div>
    </div>
  )
}

export default Feedback
